<template>  
  <v-container fluid grid-list-lg class="pb-0">
    <v-layout row wrap>      
      <v-flex lg3 xs6 v-if="this.roles.includes('sys_admin')||this.roles.includes('administrasi')">
        <v-card>
          <v-card-text class="pa-0">
            <v-container class="pa-0">
              <div class="layout row ma-0">
                <div class="sm6 xs6 flex">
                  <div class="layout column ma-0 justify-center align-center">
                    <v-icon size="65px" :color="'indigo'">account_circle</v-icon>
                  </div>
                </div>
                <div class="sm6 xs6 flex text-sm-center py-3 white--text" :class="'indigo'">
                  <div class="headline">{{fm.signup}}</div>
                  <span class="caption">signup</span>
                </div>
              </div>
            </v-container>
          </v-card-text>  
          <v-divider></v-divider>
          <v-card-text v-if="chart.signup.show"  class="pa-0 pt-3">
            <echart :option="chart.signup.option" height="200px"></echart>                        
          </v-card-text>
        </v-card>   
      </v-flex>
      <v-flex lg3 xs6>
        <v-card>
          <v-card-text class="pa-0">
            <v-container class="pa-0">
              <div class="layout row ma-0">
                <div class="sm6 xs6 flex">
                  <div class="layout column ma-0 justify-center align-center">
                    <v-icon size="65px" :color="'pink'">assignment_ind</v-icon>
                  </div>
                </div>
                <div class="sm6 xs6 flex text-sm-center py-3 white--text" :class="'pink'">
                  <div class="headline">{{parseInt(fm.adm.l)+parseInt(fm.adm.p)}}</div>
                  <span class="caption">administrasi</span>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text v-if="chart.adm.show"  class="pa-0 pt-3">
            <echart :option="chart.adm.option" height="200px"></echart>
          </v-card-text>
        </v-card>   
      </v-flex>
      <v-flex lg3 xs6>
        <v-card>
          <v-card-text class="pa-0">
            <v-container class="pa-0">
              <div class="layout row ma-0">
                <div class="sm6 xs6 flex">
                  <div class="layout column ma-0 justify-center align-center">
                    <v-icon size="65px" :color="'blue'">local_atm</v-icon>
                  </div>
                </div>
                <div class="sm6 xs6 flex text-sm-center py-3 white--text" :class="'blue'">
                  <div class="headline">{{parseInt(fm.pay.l)+parseInt(fm.pay.p)}}</div>
                  <span class="caption">pay</span>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text v-if="chart.pay.show"  class="pa-0 pt-3">
            <echart :option="chart.pay.option" height="200px"></echart>
          </v-card-text>
        </v-card>   
      </v-flex>
      <v-flex lg3 xs6>
        <v-card>
          <v-card-text class="pa-0">
            <v-container class="pa-0">
              <div class="layout row ma-0">
                <div class="sm6 xs6 flex">
                  <div class="layout column ma-0 justify-center align-center">
                    <v-icon size="65px" :color="'yellow'">local_library</v-icon>
                  </div>
                </div>
                <div class="sm6 xs6 flex text-sm-center py-3" :class="'yellow'">
                  <div class="headline">{{parseInt(fm.quran.l)+parseInt(fm.quran.p)}}</div>
                  <span class="caption">Lulus Quran</span>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text v-if="chart.quran.show" class="pa-0 pt-3">
            <echart :option="chart.quran.option" height="200px"></echart>
          </v-card-text>
        </v-card>   
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-toolbar dense flat color="blue" dark>
            <v-toolbar-title class="caption">Update : <strong>{{$moment().format('dddd, DD/MM/YYYY HH:mm')}} WIB</strong></v-toolbar-title>
          </v-toolbar>
          <v-card-text class="">
            <table class="table-border">
              <thead>
                <tr>
                  <th rowspan="2">tingkat</th>
                  <th rowspan="2">jurusan</th>
                  <th colspan="3">PA</th>
                  <th colspan="3">PI</th>
                  <th colspan="3">total</th>
                </tr>
                <tr>
                  <th>SB</th>
                  <th>BB</th>
                  <th>TOTAL</th>
                  <th>SB</th>
                  <th>BB</th>
                  <th>TOTAL</th>
                  <th>SB</th>
                  <th>BB</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="fm.pay.sd">
                  <td>SD</td>
                  <td></td>
                  <td class="text-xs-right">{{fm.pay.sd.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.sd.l)-parseInt(fm.pay.sd.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.sd.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.sd.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.sd.p)-parseInt(fm.pay.sd.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.sd.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.sd.l)+parseInt(fm.pay.sd.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.sd.l)+parseInt(fm.adm.sd.p))-(parseInt(fm.pay.sd.l)+parseInt(fm.pay.sd.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.sd.l)+parseInt(fm.adm.sd.p)}}</strong></td>
                </tr>
                <tr  v-if="fm.pay.smp">
                  <td>SMP</td>
                  <td></td>
                  <td class="text-xs-right">{{fm.pay.smp.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.smp.l)-parseInt(fm.pay.smp.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.smp.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.smp.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.smp.p)-parseInt(fm.pay.smp.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.smp.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.smp.l)+parseInt(fm.pay.smp.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.smp.l)+parseInt(fm.adm.smp.p))-(parseInt(fm.pay.smp.l)+parseInt(fm.pay.smp.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.smp.l)+parseInt(fm.adm.smp.p)}}</strong></td>
                </tr>
                <tr  v-if="fm.pay.ma">
                  <td>MA</td>
                  <td></td>
                  <td class="text-xs-right">{{fm.pay.ma.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ma.l)-parseInt(fm.pay.ma.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ma.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.ma.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ma.p)-parseInt(fm.pay.ma.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ma.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.ma.l)+parseInt(fm.pay.ma.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.ma.l)+parseInt(fm.adm.ma.p))-(parseInt(fm.pay.ma.l)+parseInt(fm.pay.ma.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.ma.l)+parseInt(fm.adm.ma.p)}}</strong></td>
                </tr>
                <tr v-if="fm.pay.ipa" class="blue-grey lighten-5">
                  <td></td>
                  <td>IPA</td>
                  <td class="text-xs-right">{{fm.pay.ipa.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ipa.l)-parseInt(fm.pay.ipa.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ipa.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.ipa.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ipa.p)-parseInt(fm.pay.ipa.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ipa.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.ipa.l)+parseInt(fm.pay.ipa.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.ipa.l)+parseInt(fm.adm.ipa.p))-(parseInt(fm.pay.ipa.l)+parseInt(fm.pay.ipa.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.ipa.l)+parseInt(fm.adm.ipa.p)}}</strong></td>
                </tr>
                <tr v-if="fm.pay.ips" class="blue-grey lighten-5">
                  <td></td>
                  <td>IPS</td>
                  <td class="text-xs-right">{{fm.pay.ips.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ips.l)-parseInt(fm.pay.ips.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ips.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.ips.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.ips.p)-parseInt(fm.pay.ips.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.ips.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.ips.l)+parseInt(fm.pay.ips.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.ips.l)+parseInt(fm.adm.ips.p))-(parseInt(fm.pay.ips.l)+parseInt(fm.pay.ips.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.ips.l)+parseInt(fm.adm.ips.p)}}</strong></td>
                </tr>
                <tr v-if="fm.pay.agama" class="blue-grey lighten-5">
                  <td></td>
                  <td>AGAMA</td>
                  <td class="text-xs-right">{{fm.pay.agama.l}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.agama.l)-parseInt(fm.pay.agama.l)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.agama.l}}</strong></td>
                  <td class="text-xs-right">{{fm.pay.agama.p}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.agama.p)-parseInt(fm.pay.agama.p)}}</td>
                  <td class="text-xs-right"><strong>{{fm.adm.agama.p}}</strong></td>
                  <td class="text-xs-right">{{parseInt(fm.pay.agama.l)+parseInt(fm.pay.agama.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.agama.l)+parseInt(fm.adm.agama.p))-(parseInt(fm.pay.agama.l)+parseInt(fm.pay.agama.p))}}</td>
                  <td class="text-xs-right"><strong>{{parseInt(fm.adm.agama.l)+parseInt(fm.adm.agama.p)}}</strong></td>
                </tr>               
              </tbody>
              <tfoot>
                <tr class="green white--text">
                  <td colspan="2">JUMLAH</td>
                  <td class="text-xs-right">{{parseInt(fm.pay.l)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.l)-parseInt(fm.pay.l)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.l)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.pay.p)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.p)-parseInt(fm.pay.p)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.p)}}</td>
                  <td class="text-xs-right">{{parseInt(fm.pay.l)+parseInt(fm.pay.p)}}</td>
                  <td class="text-xs-right">{{(parseInt(fm.adm.l)+parseInt(fm.adm.p))-(parseInt(fm.pay.l)+parseInt(fm.pay.p))}}</td>
                  <td class="text-xs-right">{{parseInt(fm.adm.l)+parseInt(fm.adm.p)}}</td>
                </tr>
              </tfoot>
            </table>
            <p class="mt-3">
              Keterangan :
              <ul>
                <li>SB : Sudah Bayar</li>
                <li>BB : Belum Bayar</li>
              </ul>
            </p>
            <p>
              Total Lulus Quran : <strong>{{parseInt(fm.quran.l)+parseInt(fm.quran.p)}}</strong>
            </p>            
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>  
</template>
<script>
import User   from '@/util/models/User';
import Model  from '@/apps/admin/models/Dashboard'
import Echart from '@/components/chart/echart';  

const  model = new Model();

export default {
  components: {Echart},
  props : {
    toggle_tingkat : Array
  },
  data:()=>({    
    roles : User.roles(), 
    fm  : {
      signup : 0,
      adm : {l:0, p:0},
      pay : {l:0, p:0},
      quran : {l:0, p:0}, 

    },
    chart : {
      signup: {show : false,option : {},},
      adm   : {show : false,option : {},},
      pay   : {show : false,option : {},},
      quran : {show : false,option : {},},
    },
    barOption : {   
        tooltip : {
            trigger: 'axis'
        },
        legend: {
            data:['laki-laki','perempuan']
        },
        /*toolbox: {
            show : true,
            feature : {
                dataView : {show: true, readOnly: false},
                magicType : {show: true, type: ['line', 'bar']},
                restore : {show: true},
                saveAsImage : {show: true}
            }
        },*/
        calculable : true,
        xAxis : [
            {
                type : 'category',
                data : ['SD','SMP','MA']
            }
        ],
        yAxis : [
            {
                type : 'value'
            }
        ],
        series : [
            {
                name:'laki-laki',
                type:'bar',
                data:[null, null, null],                
            },
            {
                name:'perempuan',
                type:'bar',
                data:[null, null, null],                                
            }
        ]
    },
    templateOption : {
        /*title : {
            text: 'Title',
            //subtext: 'PerKota',
            x:'center'
        },*/
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },        
        /*legend: {
            x : 'center',
            y : 'bottom',
            data:['branch1','branch2','branch3','branch4','branch5'],
            id:[1,2,3,4,5],
        },*/
        series : [
            {
                name: 'Jumlah',
                type: 'pie',                
                radius : [40, 60],
                center: ['50%', '50%'],                
                data:[
                    {value:null, name:'laki-laki', id:1},
                    {value:null, name:'perempuan', id:2},                    
                ],
                 itemStyle : {
                    normal : {
                        label : {
                            show : true,
                            formatter : "{b}\n\n{c} : {d}%"
                        },
                        labelLine : {
                            show : true
                        },
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },                    
                },                
            }
        ]
    },   
  }),
  watch:{
    toggle_tingkat(newArr){
      model.miniStatistic({tingkat:newArr}).then(data=>{
        Object.assign(this.fm, data)
        this.showChart();
      });
    }
  },
  computed: {                  
  },
  mounted(){
    model.miniStatistic({}).then(data=>{
      Object.assign(this.fm, data)
      this.showChart();
    });
  },
  methods:{
    showChart(){
      this.chart.signup.show = false;
      this.chart.signup.option = JSON.parse(JSON.stringify(this.templateOption));
      let serius = (parseInt(this.fm.adm.l)+parseInt(this.fm.adm.p));
      this.chart.signup.option.series[0].data = [
        {value:serius, name:'serius', id:1},
        {value:(parseInt(this.fm.signup) - serius), name:'coba-coba', id:2},
      ];
      setTimeout(()=>{this.chart.signup.show = true},300);
      
      this.chart.adm.show = false;
      this.chart.adm.option = JSON.parse(JSON.stringify(this.barOption));
      this.chart.adm.option.series[0].data = [parseInt(this.fm.adm.sd.l),parseInt(this.fm.adm.smp.l),parseInt(this.fm.adm.ma.l)];
      this.chart.adm.option.series[1].data = [parseInt(this.fm.adm.sd.p),parseInt(this.fm.adm.smp.p),parseInt(this.fm.adm.ma.p)];
      setTimeout(()=>{this.chart.adm.show = true},300);
      
      this.chart.pay.show = false;
      this.chart.pay.option = JSON.parse(JSON.stringify(this.barOption));
      this.chart.pay.option.series[0].data = [parseInt(this.fm.pay.sd.l),parseInt(this.fm.pay.smp.l),parseInt(this.fm.pay.ma.l)];
      this.chart.pay.option.series[1].data = [parseInt(this.fm.pay.sd.p),parseInt(this.fm.pay.smp.p),parseInt(this.fm.pay.ma.p)];      
      setTimeout(()=>{this.chart.pay.show = true},300);
      
      this.chart.quran.show = false;
      this.chart.quran.option = JSON.parse(JSON.stringify(this.barOption));
      this.chart.quran.option.series[0].data = [parseInt(this.fm.quran.sd.l),parseInt(this.fm.quran.smp.l),parseInt(this.fm.quran.ma.l)];
      this.chart.quran.option.series[1].data = [parseInt(this.fm.quran.sd.p),parseInt(this.fm.quran.smp.p),parseInt(this.fm.quran.ma.p)];      
      setTimeout(()=>{this.chart.quran.show = true},300);
      
    }
  }
};
</script>
<style>
.table-border {
  border-collapse: collapse;
}
.table-border td,.table-border th{
  border:1px solid #000;
  padding:5px 10px;
}
</style>
